import {management} from '../../../..'

import {DeleteBySectorAndIntervalUseCase} from "./deleteManagementBySectorAndInterval";

import {ManagementRepository} from '../../../infra/knex/repositories/management'

export const deleteManagementBySectorAndInterval=()=>{
  const repository=new ManagementRepository(management)

  const deleteManagementBySectorAndInterval= new  DeleteBySectorAndIntervalUseCase(repository)

  return deleteManagementBySectorAndInterval
}
